import { FunctionComponent } from "react";

interface ComingSoonProps {}

const ComingSoon: FunctionComponent<ComingSoonProps> = () => {
  return (
    <>
      <div className="flex flex-col align-center justify-center text-center h-full">
        <h1 className="text-4xl">Dashboard Coming Soon</h1>
      </div>
    </>
  );
};

export default ComingSoon;
